
export class Help {
  static formatVolume (num: string | number) {
    if (!num) {
      return num;
    }
    num = (num || 0);
    const arr = num.toString().split('.');
    num = arr[0];
    let end = arr[1] ? '.' + arr[1] : '';
    let result = '';
    const symbol = num.startsWith('-') ? '-' : '';
    if (num.startsWith('-')) {
      num = num.replace('-', '');
    }
    if (Number(num) < 1000) {
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
    } else if (Number(num) < 1000000) {
      result = `${parseFloat(`${(Number(num) / 1000)}`)}`
      end = 'K'
    } else if (Number(num) < 1000000000) {
      result = `${parseFloat(`${(Number(num) / 1000000)}`)}`
      end = 'M'
    } else {
      result = `${parseFloat(`${(Number(num) / 1000000000)}`)}`
      end = 'B'
    }

    return symbol + result + end;
  }

  static hideMiddlePart(str: string) {
    if (str.length <= 10) { // 如果字符串长度小于等于10，不需要替换
      return str;
    }
  
    const prefix = str.slice(0, 6); // 获取前六位
    const suffix = str.slice(-4); // 获取后四位
    return `${prefix}...${suffix}`; // 拼接返回
  }
}